import { Product, StateElement } from "@components/templates/store-locator";
import { Store } from "@storeLocator/storeType";

const generatePageMeta = (states: StateElement[], store: Store): string => {
  // Find the current state
  const currentState = states.find(
    (state) => state.elements.state_abbreviation.value === store.province
  );

  let pageMeta: string;

  // Check if products are available
  if (currentState?.elements.products.value.length) {
    // Extract product names
    const products = currentState.elements.products.value.map(
      (product) => product.elements.product_name.value
    );

    // Function to find the largest amount
    const findLargestAmount = (data: Product[]): string => {
      const amounts = data.map((product) =>
        parseFloat(product.elements.max_amount.value.replace(/,/g, ""))
      );
      const maxAmount = Math.max(...amounts);
      return maxAmount.toLocaleString();
    };

    // Find the largest amount
    const largestAmount = findLargestAmount(
      currentState.elements.products.value
    );

    // Construct the pageMeta string for products
    pageMeta = `Looking for ${products.join(" or ")} in ${
      store.city
    }? Visit CheckSmart at ${
      store.streetAndNumber
    } for a cash loan up to $${largestAmount}.`;
  } else {
    // Construct the pageMeta string for services when no products are available
    pageMeta = `Looking for services in ${store.city}? Visit CheckSmart at ${store.streetAndNumber} for a variety of financial services.`;
  }

  return pageMeta;
};

export default generatePageMeta;
